export const INVESTOR_SESSION_KEY = 'vexu.investorAccess'

/**
 * Front-end gate for the investor deck. Replace with a real auth service
 * before wider distribution — this only keeps the deck out of casual view.
 */
const CREDENTIALS: { email: string; password: string }[] = [
  { email: 'investor@vexu.ai', password: 'Vexu2026' },
  { email: 'accounts@vexu.ai', password: 'Accounts@0123' },
  { email: 'accounting@vexu.ai', password: 'Alaa@0123' },
  { email: 'invest@vexu.ai', password: 'Invest@91230' },
]

export function verifyInvestorCredentials(
  email: string,
  password: string,
): boolean {
  const normalized = email.trim().toLowerCase()
  return CREDENTIALS.some(
    (entry) => entry.email === normalized && entry.password === password,
  )
}

export function readInvestorSession(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return (
      window.localStorage.getItem(INVESTOR_SESSION_KEY) === 'granted' ||
      window.sessionStorage.getItem(INVESTOR_SESSION_KEY) === 'granted'
    )
  } catch {
    return false
  }
}

export function writeInvestorSession(remember: boolean) {
  if (typeof window === 'undefined') return
  try {
    const store = remember ? window.localStorage : window.sessionStorage
    store.setItem(INVESTOR_SESSION_KEY, 'granted')
  } catch {
    /* storage unavailable — session stays in memory only */
  }
}
